import { gql } from '@apollo/client';

export const JOB_SPELL_CHECK_QUERY = gql`
  query JobSpellCheck (
    $jobId: Int
    $texts: [String!]!
  ) {
      jobSpellCheck (
       jobId: $jobId
       texts: $texts
      ) {
        word
        suggestions
      }
  }
`;

export const JOB_SPELL_IGNORES_QUERY = gql`
  query jobSpellIgnores (
    $jobId: Int!
  ) {
    jobSpellIgnores(
      jobId: $jobId
    ) {
      id
      word
      userId
    }
  }
`;
